export const Plan = {
  FREE: 'free',
  STARTER: 'starter',
  PRO: 'pro',
  PREMIUM: 'premium'
};

export const BillingPeriod = {
  MONTHLY: 'monthly',
  YEARLY: 'yearly'
};

export const GENERATE_RESULTS_LIMIT_BY_PLAN = {
  [Plan.FREE]: 20,
  [Plan.STARTER]: 800,
  [Plan.PRO]: 2000,
  [Plan.PREMIUM]: 5000
};

export const WORDS_BY_PLAN = {
  [Plan.FREE]: 300,
  [Plan.STARTER]: 500,
  [Plan.PRO]: 750,
  [Plan.PREMIUM]: 1000
};

export const PaymentType = {
  GCASH: 'gcash',
  WAIVED: 'waived'
};

export const NO_CUSTOMER_PORTAL_PAYMENT_TYPES = [PaymentType.GCASH, PaymentType.WAIVED];

export const PRO_PREMIUM_PLANS = [Plan.PRO, Plan.PREMIUM];

export const CREDITS_FOR_FIFTY_PESOS = 100;

export const FREE_CREDITS = 20;
